import { SimpleGrid, Stack } from '@mantine/core'
import React from 'react'
import { SectionPlaceholder } from 'src/components'
import { MenuLinks, OpensourceContent } from 'src/content'
import { OpensourceCard } from './components'

export interface OpensourceProps {}

export const Opensource: React.FC<OpensourceProps> = () => {
  const { Opensource: openSourceData } = OpensourceContent
  const { MenuAnchor } = MenuLinks

  return (
    <SectionPlaceholder
      // title="Opensource"
      title="Open Source & Developer Tooling"
      subTitle='console.log("Contributing for better software");'
      anchorClassName={MenuAnchor.Opensource}
    >
      <Stack mt="lg">
        <SimpleGrid
          cols={3}
          breakpoints={[
            { maxWidth: 'md', cols: 2 },
            { maxWidth: 'sm', cols: 1 },
          ]}
          spacing={30}
        >
          {openSourceData.length &&
            openSourceData.map((item, index) => {
              return <OpensourceCard key={index} {...item} />
            })}
        </SimpleGrid>
      </Stack>
    </SectionPlaceholder>
  )
}
